<template>
  <div class="genBox">
    <!-- 绘制封面图 -->
    <canvas ref="canvas" id="myCanvas" width="686" height="196"></canvas>
    <!-- 展示绘制封面图 -->
    <img
      style="display:block;width:350px;height:100px;"
      :src="canvasImage"
      alt=""
      v-amplifyImg="canvasImage"
      v-if="selectType === 1"
    />
    <el-form ref="ruleForm" class="ruleForm" :disabled="disabled">
      <template v-if="selectType === 1">
        <el-form-item label="请输入项目描述："></el-form-item>
        <el-form-item>
          <el-input
            style="width:320px"
            v-model.lazy="inputValue"
            :maxlength="75"
            placeholder="最多输入75个字"
          ></el-input>
          <el-button type="warning" @click="confirm">
            保存
          </el-button>
        </el-form-item>
      </template>
      <template v-else>
        <el-upload
          class="avatar-uploader"
          :action="uploadImage"
          :show-file-list="false"
          :on-success="waitPicDone"
          :before-upload="preDeal"
          accept="image/*"
        >
          <img v-if="uploadUrl" :src="uploadUrl" class="avatar" />
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </template>
    </el-form>
    <el-radio-group
      v-model="selectType"
      :disabled="disabled"
      @change="onChangeType"
    >
      <el-radio :label="1">使用默认图片</el-radio>
      <el-radio :label="2">自行上传图片</el-radio>
    </el-radio-group>
  </div>
</template>

<script>
import { uploadImageAjax, uploadImage } from '@/api/ajax';
import { mapState } from 'vuex';
export default {
  props: {
    initUrl: {
      type: String,
      default: ''
    },
    initType: {
      type: Number,
      default: 1
    },
    oldUrl: {
      type: String,
      default: ''
    },
    auditStatus: {
      type: [Number, String]
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      uploadImage,
      inputValue: '',
      color: '#fff',
      ctx: '', // canvas
      imgW: 686, // drawImage 宽
      imgH: 196,
      fontSize: 24, // 文字大小 PX 也是高度
      fontWidth: 0, // 文本宽度
      canvasImage: '',
      uploadUrl: '',
      selectType: 1
    };
  },
  watch: {
    initType: {
      handler(v) {
        this.selectType = v;
      },
      immediate: true
    },
    // 输入内容更变重新绘制图片
    inputValue(v) {
      this.drawImage(v);
    }
  },
  computed: {
    ...mapState({
      projectDefaultBg: state => state.homeProject.projectDefaultBg
    })
  },
  methods: {
    onChangeType(v) {
      this.selectType = v;
      this.$emit('changeType', v);
      if (v === 1) {
        if (!this.canvasImage) {
          this.drawImage();
        }
        // 绘制封面图
        this.$emit('finish', this.canvasImage);
      }
      if (v === 2) {
        // 切换后使用初始图片
        this.$emit('finish', this.uploadUrl);
      }
    },
    handleImagesUrlBefore(file) {
      //判断图片尺寸
      var _this = this;
      return new Promise(function(resolve, reject) {
        let reader = new FileReader();
        reader.onload = function(event) {
          let image = new Image();
          image.onload = function() {
            let width = this.width;
            let height = this.height;
            if (width < 700) {
              _this.$alert('图片宽度不得小于700！', '提示', {
                confirmButtonText: '确定'
              });
              reject();
            } else if (height < 200) {
              _this.$alert('图片高度不得小于200！', '提示', {
                confirmButtonText: '确定'
              });
              reject();
            } else if (width / height !== 3.5) {
              _this.$alert('图片宽高比必须为3.5：1！', '提示', {
                confirmButtonText: '确定'
              });
              reject();
            } else {
              resolve();
            }
          };
          image.src = event.target.result;
        };
        reader.readAsDataURL(file);
      });
    },
    waitPicDone(response) {
      //自行上传完成
      this.uploadUrl = response.data;
      this.$emit('finish', this.uploadUrl);
    },
    preDeal(file) {
      //预处理图片
      return this.handleImagesUrlBefore(file);
    },
    fillTextAutoWrapCenter(ctx, text, x, y, maxWidth, lineHeight) {
      let line = '';
      let lines = [];
      for (let i = 0; i < text.length; i++) {
        const testLine = line + text[i];
        const testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxWidth && i > 0) {
          lines.push(line);
          line = text[i];
        } else {
          line = testLine;
        }
      }
      lines.push(line);
      const totalHeight = lines.length * lineHeight;
      ctx.textAlign = 'center';
      lines.forEach((l, i) => {
        ctx.fillText(l, x, y + i * lineHeight - totalHeight / 2);
      });
    },
    drawImage(text = '') {
      //绘制图片
      let img = new Image();
      img.crossOrigin = '*';
      // 编辑使用默认图
      img.src = this.oldUrl;
      img.onload = () => {
        this.ctx.drawImage(img, 0, 0, this.imgW, this.imgH);
        this.ctx.font = `${this.fontSize}px 'SimHei'`;
        this.ctx.fillStyle = this.color;
        // this.ctx.textAlign = 'center';
        this.ctx.textBaseline = 'top';
        this.fillTextAutoWrapCenter(
          this.ctx,
          text,
          this.$refs.canvas.width / 2,
          this.$refs.canvas.height / 2 - 35,
          this.imgW - 40,
          24
        );
        this.toDataURL();
      };
    },
    async confirm() {
      if (!this.inputValue) {
        this.$message({
          type: 'error',
          message: '请输入项目描述，用于生成封面图'
        });
        return;
      }
      //输入文字后保存
      this.$refs.canvas.toBlob(async blob => {
        let fd = new FormData();
        fd.append('file', blob);
        let {
          data: { data }
        } = await uploadImageAjax(fd);
        this.$message({
          type: 'success',
          message: '封面图保存成功'
        });
        // 保存后同步canvasImage，防止切换后提交项目时传的时base64原地址
        this.canvasImage = data;
        this.$emit('done', data);
      }, 'image/png');
    },
    toDataURL() {
      this.canvasImage = this.$refs.canvas.toDataURL('image/png', 1);
    },
    close() {
      this.$emit('dialog-close', true);
    }
  },
  created() {
    // 只监听一次赋值变化
    const unwatchInitUrl = this.$watch(
      'initUrl',
      v => {
        if (v) {
          // 默认图片tab赋值
          if (this.initType === 1) {
            this.canvasImage = v;
          }
          // 自行上传tab赋值
          if (this.initType === 2) {
            this.uploadUrl = v;
          }
          unwatchInitUrl();
        }
        this.$nextTick(() => {
          if (!this.ctx) {
            this.ctx = this.$refs.canvas.getContext('2d');
          }
        });
      },
      {
        immediate: true
      }
    );
  }
};
</script>

<style scoped lang="scss">
.radio-img {
  width: 70px;
  height: 20px;
}
#myCanvas {
  display: none;
}
</style>
<style lang="scss">
.genBox {
  .avatar-uploader,
  .avatar {
    width: 350px;
    height: 100px;
  }
  .avatar-uploader {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
  }
  .avatar-uploader:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 350px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>
